import { Card, CardBody, CardHeader, CardTitle, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState, useMemo } from "react";
import { Api } from '../../componentes/Api';
import Moment from "moment";

import * as XLSX from "xlsx"
import * as moment from "moment";


import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'



const modeloDatos = {
    citaID: 0,
    nombrePaciente: "",
    telefono: 0,
    nombreTratamiento: "",
    fecha: new Date,
    hora: "",
    nombreEspecialista: "",
    comentario: "",
    confirmacionCita: true,
    notificacionCorreo: false,
    notificacionWhatsapp: true,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}


const ReporteCitas = () => {
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [pendiente, setPendiente] = useState(false);
    const [vercal, setvercal] = useState(true);
    const [tabla, setTabla] = useState([]);
    const [EmpresaD, setEmpresaD] = useState([]);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Impresion, setImpresion] = useState(false);
    const [R_API, setR_API] = useState("")
    const [verModalImpresion, setVerModalImpresion] = useState(true);

let correo = JSON.parse(user);

    const Empresa = async () => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + correo.empresaID );
        if (response.ok) {
            let data = await response.json()
            setEmpresaD(data)
        }
     

    }
 
    const buscar = () => {

        setPendiente(true)
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        let _fechaInicio = Moment(fechaInicio).format('YYYY-MM-DD')//.toLocaleDateString('es-PE', options)
        let _fechaFin =  Moment(fechaFin).format('YYYY-MM-DD') //.toLocaleDateString('es-PE', options)
        obtenerDatos(_fechaInicio, _fechaFin);
    }
    const obtenerDatos = async (fi,ff) => {
        let response = await fetch(Api + "Citas/ReporteCitas/" + fi + "/" + ff + "/" + correo.correo);
        if (response.ok) {
            let data = await response.json()
            if (data.length < 1) {
                Swal.fire(
                    'Opps!',
                    'No se encontraron resultados',
                    'warning'
                )
           
            }
        
            setPendiente(false)
            setTabla(data);
            toEvent(data)
            setR_API(Api + "Citas/ReporteCitas/" + fi + "/" + ff + "/" + correo.correo)
            //                ).catch ((error) => {
            //    setTabla([]);
            //    Swal.fire(
            //        'Opps!',
            //        'No se pudo encontrar información',
            //        'error'
            //    )
            //})
        }
    }

        //let response = fetch(Api + "Citas/ReporteCitas/" + _fechaInicio + "/" + _fechaFin);

        //if (response.ok) {
        //    let data =  response.json()
        //    setTabla(data)
        //}
        
        


   

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.nombrePaciente,
        },
        {
            name: 'Fecha Cita',
            selector: row => (moment(row.fecha).format("DD/MM/YYYY")),
        },
        {
            name: 'Hora',
            selector: row => row.hora ,
        },
        {
            name: 'Cita Conf',
            selector: row => row.confirmacionCita,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.confirmacionCita ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.confirmacionCita ? "Si" : "No"}</span>
                )
            }
        },
        {
            name: 'Telefono',
            selector: row => row.telefono,
        },
        {
            name: 'Tratamiento',
            selector: row => row.nombreTratamiento,
        },
        {
            name: 'Asignado A',
            selector: row => row.nombreEspecialista,
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const exportarExcel = () => {
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet(tabla);

        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, "Reporte Citas.xlsx")
    }

    useEffect(() => {
        buscar()
        Empresa()
    }, [])



    const estilos = `
          <link href="/css/sb-admin-2.min.css" rel="stylesheet" type="text/css">

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
  <style>
        /* Estilos generales */

        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f4f6f8;
            color: #333;
        }

        .container {
            width: 90%;
            max-width: 1200px;
            margin: auto;
            padding: 20px;
        }

        /* Encabezado */

        .header {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            background-color: #ffffff;
            padding: 15px;
            border-radius: 8px;
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
        }

        .logo {
            width: 80px;
            margin-right: 20px;
        }

        .company-info {
            line-height: 1.4;
            flex: 1;
        }

        .company-info h1 {
            margin: 0;
            font-size: 1.5em;
            color: #007bff;
        }

        .company-info p {
            margin: 0;
            font-size: 0.9em;
            color: #555;
        }

        /* Contenedor del contenido principal */

        .content {
            background-color: #ffffff;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        }

        .content h2 {
            color: #007bff;
            margin-bottom: 5px;
        }

        .content p {
            margin-top: 0;
            color: #555;
        }

        /* Tabla */

        .table-container {
            overflow-x: auto;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            min-width: 700px;
        }

        table th,
        table td {
            padding: 10px;
            text-align: left;
            border-bottom: 1px solid #ddd;
            font-size: 0.9em;
        }

        table th {
            background-color: #f8f9fa;
            font-weight: bold;
        }

        .badge {
            padding: 5px 10px;
            border-radius: 4px;
            color: #fff;
            font-size: 0.85em;
            display: inline-block;
        }

        .badge-success {
            background-color: #198754;
        }

        .badge-danger {
            background-color: #dc3545;
        }
    </style>
    `;



    const imprimirRecibo = () => {
        const recibo = document.getElementById("reciboPago").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Recibo de Pago</title>");
        ventana.document.write(estilos);
        ventana.document.write("</head><body>");
     
        ventana.document.write(recibo);
        ventana.document.write("</body></html>");
        ventana.document.close();
        ventana.print();
    };



    const citas = [
        { id: 1, paciente: 'Juan Pérez', servicio: 'Consulta', fecha: '2025-08-21', hora: '08:00', duracionMin: 30, medico: 'Dra. Gómez' },
        { id: 2, paciente: 'Ana Ruiz', servicio: 'Control', fecha: '2025-08-22', hora: '10:30', duracionMin: 45, medico: 'Dr. Díaz' },
    ];

    const toEvent = (c) => {
        // Construir Date local (ajusta timeZone en el calendario para evitar corrimientos)
        const start = new Date(`${c.fecha}T${c.hora}:00`);
        const end = new Date(start.getTime() + (c.duracionMin ?? 30) * 60 * 1000);

        return {
            id: c.id,
            title: `${c.paciente} · ${c.servicio}`,
            start,
            end,
            extendedProps: { medico: c.medico, ...c },
        };
    };
    const events = useMemo(() => citas.map(toEvent), [/* depende de tu estado de citas */]);



    return (
        <>
          

            <Row>
                <Col sm={12}>
                    <Card>
                        <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                            Reporte de Citas
                        </CardHeader>
                        <CardBody>
                            <Row className="align-items-end">

                                <Col sm={3}>
                                    <FormGroup>
                                        <Label>Fecha Inicio:</Label>
                                        <DatePicker
                                            className="form-control form-control-sm"
                                            selected={fechaInicio}
                                            onChange={(date) => setFechaInicio(date)}
                                            dateFormat='dd/MM/yyyy'
                                        />
                                    </FormGroup>
                                </Col>

                                <Col sm={3}>
                                    <FormGroup>
                                        <Label>Fecha Fin:</Label>
                                        <DatePicker
                                            className="form-control form-control-sm"
                                            selected={fechaFin}
                                            onChange={(date) => setFechaFin(date)}
                                            dateFormat='dd/MM/yyyy'
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <Button color="primary" size="sm" block onClick={buscar}>
                                            <i className="fa fa-search" aria-hidden="true"></i> Buscar
                                        </Button>
                                    </FormGroup>
                                </Col>

                                <Col sm={3}>
                                    <FormGroup>
                                        <Button color="success" size="md"   onClick={() => setImpresion(true)}>
                                            <i class="fas fa-print"></i>  
                                        </Button>
                                        <Button color="success" size="md"  onClick={exportarExcel}>
                                            <i className="fa fa-file-excel" aria-hidden="true"></i>  
                                        </Button> 
                                        <Button color="primary" size="md" onClick={() => setvercal(!vercal)}>
                                            <i className="fa fa-calendar" aria-hidden="true"></i>  
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr></hr>
                            <Row>
                                <div hidden={vercal}>
                                    
                                    <FullCalendar
                                        plugins={[dayGridPlugin]}
                                        initialView="dayGridMonth"
                                        timeZone="America/Santo_Domingo"
                                        headerToolbar={{ left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek,timeGridDay' }}
                                        events={events}
                                    />
                                </div>
                                <Col sm="12" hidden={!vercal}>
                                    <DataTable
                                        progressPending={pendiente}
                                        columns={columns}
                                        data={tabla}
                                        customStyles={customStyles}
                                    />


                                </Col>

                            </Row>

                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal className="modal-preguntas" isOpen={Impresion}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> IMPRESION  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div id="reciboPago" className="mt-4 p-3">
                  
                                <div>
                               
                                    <img src="logo.png" alt="Logo Apatech" class="logo" />
                                    <div class="company-info">
                                        <h1>{EmpresaD.descripcion}</h1>
                                        <p>{ EmpresaD.direccion}</p>
                                        <p>RNC: {EmpresaD.rnc}</p>
                                        <p>TEL: {EmpresaD.telefono} CORREO: {EmpresaD.email}</p>
                                    </div>



                                    <div class="content">
                                        <h2>Reporte Citas</h2>


                                        <div class="table-container">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Paciente</th>
                                                        <th>Teléfono</th>
                                                        <th>Especialista</th>
                                                        <th>Hora</th>
                                                        <th>Tratamiento</th>
                                                       <th>Confirmación</th>

                                                    </tr>
                                                </thead>
                                                <tbody id="clientes-body">
                                                   { ( tabla.length < 1) ? (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: "center" }}>
                                                            Sin resultados
                                                        </td>
                                                    </tr>
                                                    ) : (
                                                    tabla.map(x =>(   <tr>
                                                        <td>{x.nombrePaciente }</td>
                                                        <td>{x.telefono }</td>
                                                        <td>{x.nombreEspecialista }</td>
                                                        <td>{x.hora }</td>
                                                        <td>{x.nombreTratamiento }</td>
                                                        <td>{<span >{x.confirmacionCita ? "Si" : "No"}</span> }</td>
                                                    </tr>)))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>






                                <Button color="secondary" onClick={() => imprimirRecibo()}>Imprimir Recibo</Button>
                         
                    </div>
                    {/*<Row>*/}
                    {/*    <FormGroup>*/}
                    {/*        {<iframe*/}
                    {/*            src={"/Informes/Citas/reportecitas.html?API=" + R_API}*/}
                    {/*            title="Contenido HTML"*/}
                    {/*            style={{ width: '100%', height: '1100px', border: 'none' }}*/}

                    {/*        />}*/}


                    {/*        <Button size="sm" color="danger"*/}
                    {/*            onClick={() => setImpresion(false)}*/}
                    {/*        >Cerrar</Button></FormGroup>*/}
                    {/*</Row>*/}
                </ModalBody>

            </Modal>



        </>
    )
}

export default ReporteCitas;